import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import { telNumber, officeNumber, emailAddress } from '../../utils/variables'
import IconMail from '../../assets/images/icon-blue-envelope.svg'
import IconPhone from '../../assets/images/icon-blue-phone.svg'
import IconInstagram from '../../assets/images/icon-blue-instagram.svg'
// import LogoIPAF from '../../assets/images/logos/logo-ipaf.jpg';
// import LogoCheckatrade from '../../assets/images/logos/logo-checkatrade.jpg';
// import LogoSafeCont from '../../assets/images/logos/logo-safecontractor.jpg';
// import LogoFwc from '../../assets/images/logos/logo-fwc.jpg';
// import LogoCscs from '../../assets/images/logos/logo-cscs.jpg';

const propTypes = {
  navItems: PropTypes.array.isRequired,
}

const Footer = ({ navItems }) => {
  const currentTime = new Date()
  const currentYear = currentTime.getFullYear()
  return (
    <div className="site-footer">
      <div className="site-footer-top-row">
        <ul className="nav-footer">
          {navItems.map(item => {
            const { url, displayName } = item
            const navClass = 'nav-footer__url'
            return (
              <li className="nav-footer__item" key={displayName}>
                <Link
                  className={navClass}
                  exact
                  to={url}
                  activeClassName={`${navClass}--active`}
                >
                  {displayName}
                </Link>
              </li>
            )
          })}
        </ul>
        <p className="text">{`${currentYear} © Clear H2O Window Cleaning Ltd`}</p>
      </div>
      <div className="site-footer-bottom-row ">
        <a href={`tel:${telNumber}`} className="footer-contact-text">
          <img src={IconPhone} alt="" />
          <span>{telNumber}</span>{' '}
        </a>
        <a
          href={`mailto:${emailAddress}`}
          className="footer-contact-text footer-contact-text--email"
        >
          <img src={IconMail} alt="" />
          <span>{emailAddress}</span>{' '}
        </a>
      </div>
    </div>
  )
}

Footer.propTypes = propTypes

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js